module.exports = __webpack_public_path__ + "img/29passenger_driving.7d49c2fe.svg";